import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { cancelAppointment } from '@/api/appointments/appointmentsApi';
import { APPOINTMENTS_QUERY_KEY, WORKSPACE_ATTENTION_QUERY_KEY } from '@/constants/queryKeys';
import type { Appointment } from '@/api/appointments/appointmentsApi.types';

export function useCancelAppointmentMutation(): UseMutationResult<Appointment, Error, string> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: cancelAppointment,
    onSuccess: function invalidateAppointmentsCache() {
      queryClient.invalidateQueries({ queryKey: APPOINTMENTS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: WORKSPACE_ATTENTION_QUERY_KEY });
    },
  });
}
